import produce from 'immer';
import {
    GET_OVERLAY_CONTENT_FAILED,
} from './constant';
import { TOGGLE_OVERLAY, TRIGGERNEXTOVERLAY } from 'Constant';

/**
 * Export initalState
 *
 * @export initalState
 */
export const initialState = {
    overlayError: false,
    overlay: false,
    overlayName: '',
};

const overlayReducer = (state = initialState, action) =>
    produce(state, draft => {
        switch (action.type) {
            case GET_OVERLAY_CONTENT_FAILED:
                draft.overlayError = action.error;
                break;
            case TOGGLE_OVERLAY:
                draft.overlay = !state.overlay;
                break;
            case TRIGGERNEXTOVERLAY:
                draft.overlayName = action.name;
                draft.overlay = !state.overlay;
                break;
        }
    });

export default overlayReducer;
